import { Component, OnInit, ViewContainerRef, Injector } from '@angular/core';
import { MainComponent } from 'src/modules/base/components/main-component/main.component';
import { ActivatedRoute, Router } from '@angular/router';
import { strictEqual } from 'assert';
import _moment from 'proxies/dayjs';
import { LiquidDietItemModel } from 'src/modules/diet-kitchen/components/diet-kitchen/liquid_diet_item.model';

const moment = _moment;
@Component({
    selector: 'app-emr-diet-plan',
    templateUrl: './emr-diet-plan.component.html',
    styleUrls: ['./emr-diet-plan.component.scss'],
    standalone: false
})
export class EmrDietPlanComponent extends MainComponent implements OnInit {
  formData: any = {};
  //@Input() resource: any;
  action: any;
  data: any = [];
  bulkDiet: any[];
  idArr: any = [];
  constructor(
    public injector: Injector,
    private route: ActivatedRoute,
    public viewContainerRef: ViewContainerRef,
    public router: Router
  ) {
    super(injector, route);
  }
  liquidDiets: Array<LiquidDietItemModel> = [];
  public _currentData: any = {};

  ngOnInit() {
    this._currentData.config = {
      "submitButton": true,
      "cancelButton": true,
      "filterForm": false,
      "clearOnSave": false,
      "delegateSave": true,
      "cancelRoute": ''
    }
    this.storageService.getSessionStorageData("currentData", (data) => { // getting user info
      if (data)
        this._currentData.cardData = data;
    })

    if (this.action && this.action != undefined && this.action.action == 'popup_form') {
      this._currentData.bulkData = this.data;
      if (this._currentData.bulkData.length > 1) {
        var firstName = this._currentData.bulkData[0].dietType;
        this.bulkDiet = [];
        var isEqual = true;
        for(let j = 1; j < this._currentData.bulkData.length; j++) {
          this.bulkDiet.push(this._currentData.bulkData[j].dietType);
          console.log("dietName==>", this.bulkDiet);
        }
        if (this.bulkDiet) {
          for(let i = 0; i < this.bulkDiet.length; i++) {
            if (firstName != this.bulkDiet[i]) {
              isEqual = false;
              break;
            }
          }
        }
        if (isEqual) {
          this.baseService.action(this.data, 'bulkPlan_validate', 'diet-kitchen', 'dietOrder_acknowledge').subscribe(res => {
            console.log("ans", res);
            this._currentData.currentAction = 'ADD';
            this.bindResource();
          });
        } else {
          setTimeout(() => {
            this.closePopup();
          });
          this.alerts.error("Can't Bulk Plan Due To Different Diet Type");
        }
      } else {
        this.baseService.action(this.data, 'bulkPlan_validate', 'diet-kitchen', 'dietOrder_acknowledge').subscribe(res => {
          console.log("only one entry==>", res);
          this._currentData.currentAction = 'ADD';
          this.bindResource();
        });
      }
    } else {
      this._currentData.currentAction = 'ADD';
      this.bindResource();
    }
  }

  bindResource() {
    this.baseService.getResourceDef('diet_plan_emr_form', (resouceDef) => {
      if (resouceDef) {
        this._currentData.resouceDef = resouceDef;
        this.baseService.init(resouceDef.resource);
        this.baseService.setTitleFromResouceDef(resouceDef, this._currentData.currentAction);
        this.getDataForCurdOperation(resouceDef);
      }
    });
  }

  getDataForCurdOperation(resouceDef: any) {
    if (resouceDef.form != undefined && resouceDef.form) {
      this.baseService.getReferredField(resouceDef.form, (response) => {
        this._currentData.currentFormFields = {};
        this._currentData.currentFormFields.blocks = response;
        this._currentData.currentFormFields.submitButton = true;
      });
    }
    this.getByEncounterID();
  }

  getByEncounterID() {
    this.loader.showSpinner();
    var encounterId = '';
    if (this.action && this.action != undefined && this.action.action == 'popup_form') {
      encounterId = this._currentData.bulkData[0].encounter_id;
    } else {
      encounterId = this._currentData.cardData.encounter_id;
    }
    var apiObj: any = {
      query_id: this._currentData.resouceDef.form.datasource.query_id,
      args: this._currentData.resouceDef.form.datasource.args + ":" + encounterId,
      resource: this._currentData.resouceDef.form.datasource.resource,
      application: this._currentData.resouceDef.form.datasource.application
    };
    this.baseService.getByDataSource(apiObj).subscribe(
      (data: any) => {
        if (data.erroCode == -1) {
          this.alerts.error(data.message);
        } else {
          if (data.resource != undefined && data.resource.length > 0) {
            this._currentData.currentData = data.resource[0];
            if (this._currentData.currentData.dietType == "liquid" || this._currentData.currentData.dietType == "rtFeed") {
              this.createLiquidItems(this._currentData.currentData.frequency, this._currentData.currentData.quantity);
            }
            this._currentData.currentData.liquid_data = JSON.parse(JSON.stringify(this.liquidDiets));
            //this.setTableWidth(this._currentData.currentData.dietType);
          } else {
            this._currentData.currentData = [];
          }
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
      }
    )
  }

  // setTableWidth(diettype: string) {
  //   this._currentData.currentFormFields.blocks.forEach(block => {
  //     block.fields.forEach(field => {
  //       if (diettype == 'rtFeed' && field.type == 'EDITABLE-TABLE')
  //         field.min_width = "auto";
  //       else field.min_width = "auto";
  //     });
  //   });
  // }
  createLiquidItems(frequency: any, quantity: any, stDate?: any) {
    this.liquidDiets = [];
    if (frequency == undefined)
      frequency = 0;

    let frequencyNo: number = frequency;
    //var time = moment.duration("01:00:00");
    var time = moment().hour();
    let startDate = moment();//.startOf('day');//.valueOf();
    let endDate = moment().endOf('day').subtract(time);//.valueOf();
    if (stDate != undefined && stDate != "") {
      startDate = moment(stDate);
      endDate = moment(stDate).endOf('day').subtract(time);
    } else {
      this.formData.dietPlanFromVal = startDate.valueOf();;//set current time if diet time is not define
    }

    var duration = moment.duration(endDate.diff(startDate));
    var hours = Math.round(duration.asHours());
    if (frequency == 0) {
      const liquidDietObj = new LiquidDietItemModel();
      liquidDietObj.time = startDate.add(frequency, 'hours').valueOf();
      //liquidDietObj.volume = "";
      liquidDietObj.remarks = "";
      this.liquidDiets.push(liquidDietObj);
    } else {
      for (let i = 0; i <= hours; i = i + frequencyNo) {
        let frequencyVal = 0;
        if (i > 0)
          frequencyVal = frequencyNo;
        const liquidDietObj = new LiquidDietItemModel();
        liquidDietObj.time = startDate.add(frequencyVal, 'hours').valueOf();
        liquidDietObj.volume = quantity;
        liquidDietObj.remarks = "";
        this.liquidDiets.push(liquidDietObj);
      }
    }
  }

  onValueChanged(event) {
    var question = event.question;
    this._currentData.currentForm = event.form;
    if (this._currentData.currentForm.controls["dietType"].value == "liquid" || this._currentData.currentForm.controls["dietType"].value == "rtFeed") {
      var currentDietTypeVal = this._currentData.currentForm.controls["dietType"].value;
      var currentFrequencyVal = this._currentData.currentForm.controls["frequency"].value;
      var currentQuantityVal = this._currentData.currentForm.controls["quantity"].value;
      var currentDietPlanFromVal = this._currentData.currentForm.controls["dietPlanFrom"].value;

      if (this.formData.dietTypeVal == undefined || this.formData.frequencyVal == undefined || this.formData.quantityVal == undefined || this.formData.dietPlanFromVal == undefined) {
        if (currentDietTypeVal != this.formData.dietTypeVal) {
          this.formData.dietTypeVal = currentDietTypeVal;
          setTimeout(() => {
            this.createLiquidItems(currentFrequencyVal, currentQuantityVal, currentDietPlanFromVal);
            this._currentData.currentForm.controls["liquid_data"].setValue(JSON.parse(JSON.stringify(this.liquidDiets)));
            // if (this.formData.dietTypeVal == 'rtFeed')
            //   currentForm.controls["minWidth"].setValue('auto');
            // else if (this.formData.dietTypeVal == 'liquid') currentForm.controls["minWidth"].setValue('auto');
            // else currentForm.controls["minWidth"].setValue('auto');
          });
        }
        this.formData.dietTypeVal = currentDietTypeVal;
        this.formData.frequencyVal = currentFrequencyVal;
        this.formData.quantityVal = currentQuantityVal;
        this.formData.dietPlanFromVal = currentDietPlanFromVal;

      } else if (this.formData.dietTypeVal != undefined && this.formData.frequencyVal != undefined && this.formData.quantityVal != undefined && this.formData.dietPlanFromVal != undefined) {
        if (currentDietTypeVal != this.formData.dietTypeVal) {
          this.formData.dietTypeVal = currentDietTypeVal;
          setTimeout(() => {
            this.createLiquidItems(currentFrequencyVal, currentQuantityVal, currentDietPlanFromVal);
            this._currentData.currentForm.controls["liquid_data"].setValue(JSON.parse(JSON.stringify(this.liquidDiets)));
            // if (this.formData.dietTypeVal == 'rtFeed')
            //   currentForm.controls["minWidth"].setValue('auto');
            // else if (this.formData.dietTypeVal == 'liquid') currentForm.controls["minWidth"].setValue('auto');
            // else currentForm.controls["minWidth"].setValue('auto');
          });
        }
        if (currentFrequencyVal != this.formData.frequencyVal) {
          this.formData.frequencyVal = currentFrequencyVal;
          this.createLiquidItems(currentFrequencyVal, currentQuantityVal, currentDietPlanFromVal);
          this._currentData.currentForm.controls["liquid_data"].setValue(JSON.parse(JSON.stringify(this.liquidDiets)));
        }
        // if (currentQuantityVal != this.formData.quantityVal) {
        //   this.formData.quantityVal = currentQuantityVal;
        //   this.createLiquidItems(currentFrequencyVal);
        //   currentForm.controls["liquid_data"].setValue(JSON.parse(JSON.stringify(this.liquidDiets)));
        // }
        if (currentDietPlanFromVal != this.formData.dietPlanFromVal) {
          this.formData.dietPlanFromVal = currentDietPlanFromVal;
          this.createLiquidItems(currentFrequencyVal, currentQuantityVal, currentDietPlanFromVal);
          this._currentData.currentForm.controls["liquid_data"].setValue(JSON.parse(JSON.stringify(this.liquidDiets)));
        }
      }
    }
  }

  onSaveFinished(event) {
    this.loader.showSpinner();
    if (event.result.data != null && event.result.data.length == 0) {
      this.alerts.error('Meals are not empty', 'Failed');
      this.loader.hideSpinner();
      return false;
    } else if (event.result.liquid_data != null && event.result.liquid_data.length == 0) {
      this.alerts.error('Meals are not empty', 'Failed');
      this.loader.hideSpinner();
      return false;
    }
    if (this._currentData.currentAction == 'ADD') {
      delete event.result.id;
    }

    if (this.action && this.action != undefined && this.action.action == 'popup_form') {
      var datasource: any = {
        action: this._currentData.resouceDef.form.bulkDatasource.action,
        resource: this._currentData.resouceDef.form.bulkDatasource.resource,
        application: this._currentData.resouceDef.form.bulkDatasource.application
      };
      for(let i = 0; i < this._currentData.bulkData.length; i++) {
        this.idArr.push(this._currentData.bulkData[i].id);
        var ID = this.idArr.join();
        console.log("selected idArr==>", this.idArr);
        console.log("selected ID==>", ID);
      }
      event.result['id'] = ID;
      var finalData = event.result;
    } else {
      var datasource: any = {
        action: this._currentData.resouceDef.form.APIresource.datasource.action,
        resource: this._currentData.resouceDef.form.APIresource.datasource.resource,
        application: this._currentData.resouceDef.form.APIresource.datasource.application
      };
      var data = this._currentData.currentData;
      var finalData = { ...data, ...event.result };
    }

    this.baseService.action(finalData, datasource.action, datasource.application, datasource.resource).subscribe(
      (res) => {
        if (res.errCode == 0) {
          if (this.action && this.action != undefined && this.action.action == 'popup_form') {
            this.alerts.success(res.message, 'Added Successfully');
            this.closePopup();
          }
          else {
            if (this.route.snapshot.queryParams.returnUrl != undefined) {
              this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
            }
            this.alerts.success(res.message, 'Added Successfully');
          }
        } else {
          if (res.errCode == -1) {
            this.alerts.error(res.message, 'Failed');
          }
        }
        this.loader.hideSpinner();
      }, (err) => {
        console.log("error occured", err);
        this.loader.hideSpinner();
      })
  }

  closePopup() {
    this.dialogRef.close();
  }
}
